<script setup>
import {inject} from 'vue';

const openMobileMenu = inject('openMobileMenu');
</script>

<template>
    <button
        class="focus rounded-lg xl:hidden"
        aria-label="hamburger menu icon"
        @click="openMobileMenu = !openMobileMenu"
    >
        <svg
            fill="#fff"
            viewBox="0 0 24 16"
            class="size-6"
        >
            <path
                v-if="!openMobileMenu"
                fill-rule="evenodd"
                d="M0 16V14H24V16H0ZM0 9V7H24V9H0ZM0 2V0H24V2H0Z"
                clip-rule="evenodd"
                fill="white"
            />
            <path
                v-if="openMobileMenu"
                fill-rule="evenodd"
                d="M1.26703 16L0 14.733L6.73297 8L0 1.26703L1.26703 0L8 6.73297L14.733 0L16 1.26703L9.26703 8L16 14.733L14.733 16L8 9.26703L1.26703 16Z"
                fill="white"
                clip-rule="evenodd"
            />
        </svg>
    </button>
</template>
